
interface PageHeaderProps {
  upperLabel?: string;
  title: string;
  subtitle?: string;
}

const PageHeader = ({ upperLabel, title, subtitle }: PageHeaderProps) => {
  return (
    <div className="w-full bg-cover bg-center h-64 relative" style={{ backgroundImage: "url('/lovable-uploads/63560c3c-d7c3-4d91-b852-d2cd79229bf8.png')" }}>
      <div className="absolute inset-0 bg-emu-blue/20"></div>
      <div className="container mx-auto px-4 h-full flex items-end pb-8 relative z-10">
        <div>
          {upperLabel && (
            <div className="uppercase text-emu-blue font-medium tracking-wide mb-1">
              {upperLabel}
            </div>
          )}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            {title}
          </h1>
          {subtitle && (
            <p className="text-gray-700 mt-2">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
